import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=5f398cac&scoped=true&"
import script from "./expert.vue?vue&type=script&lang=ts&"
export * from "./expert.vue?vue&type=script&lang=ts&"
import style0 from "./expert.vue?vue&type=style&index=0&id=5f398cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f398cac",
  null
  
)

export default component.exports